var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-body"},[_c('Sidebar'),_c('div',{staticClass:"app-content"},[_c('Navbar'),_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }